import { safeParseJson } from '../utils/safeParseJson';
import type { ScheduleItem, ScheduleViewMode } from './scheduleTypes';

export const DG_SCHEDULE_UI_V1 = 'dg_schedule_ui_v1';

export type ScheduleUiSnapshotV1 = {
  v: 1;
  view: ScheduleViewMode;
  cursor: string; // YYYY-MM-DD
  search: string;
  filterKinds: NonNullable<ScheduleItem['kind']>[];
  filterCourseId: string;
  filterOverdueOnly: boolean;
  filterRecurringOnly: boolean;
};

function isViewMode(x: unknown): x is ScheduleViewMode {
  return x === 'agenda' || x === 'daily' || x === 'weekly' || x === 'monthly';
}

function isKind(x: unknown): x is NonNullable<ScheduleItem['kind']> {
  return (
    x === 'event' ||
    x === 'reminder' ||
    x === 'teacherBlock' ||
    x === 'appointment' ||
    x === 'meeting'
  );
}

function isYmd(x: unknown): x is string {
  if (typeof x !== 'string') return false;
  return /^\d{4}-\d{2}-\d{2}$/.test(x);
}

export function loadScheduleUiSnapshot(): ScheduleUiSnapshotV1 | null {
  if (typeof window === 'undefined') return null;
  const raw = safeParseJson<unknown>(window.localStorage.getItem(DG_SCHEDULE_UI_V1), null);
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  if (o.v !== 1) return null;
  if (!isViewMode(o.view)) return null;
  if (!isYmd(o.cursor)) return null;

  const filterKinds = Array.isArray(o.filterKinds) ? o.filterKinds.filter(isKind) : [];
  return {
    v: 1,
    view: o.view,
    cursor: o.cursor,
    search: typeof o.search === 'string' ? o.search : '',
    filterKinds,
    filterCourseId: typeof o.filterCourseId === 'string' ? o.filterCourseId : '',
    filterOverdueOnly: typeof o.filterOverdueOnly === 'boolean' ? o.filterOverdueOnly : false,
    filterRecurringOnly: typeof o.filterRecurringOnly === 'boolean' ? o.filterRecurringOnly : false,
  };
}

export function saveScheduleUiSnapshot(snapshot: ScheduleUiSnapshotV1): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(DG_SCHEDULE_UI_V1, JSON.stringify(snapshot));
  } catch {
    /* quota */
  }
}
